import React from "react";
import { any } from "prop-types";
import { connect } from "react-redux";
import FeedbackScreen from "../../common/AssessmentCreator/FeedbackScreen";

const PusterlaPollardsInductionQuestionnaireForm = ({ appData }) => {
  const retryCounter =
    appData &&
    appData.pusterlaOnboarding &&
    appData.pusterlaOnboarding.retryCounter;
  const score =
    appData && appData.pusterlaOnboarding && appData.pusterlaOnboarding.score;

  const state = {
    passed: score === 5,
    result: score,
    retryCount: retryCounter,
    numQuestions: 5,
    retakeLink: "pusterla-onboarding/assessment",
    testTitle: "Pusterla Questionnaire",
    cancelLink: "pusterla-onboarding",
    retryLimit: 3,
  };

  return <FeedbackScreen state={state} />;
};

PusterlaPollardsInductionQuestionnaireForm.propTypes = {
  appData: any,
};

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PusterlaPollardsInductionQuestionnaireForm);
